/**
 * Highlights the active bulk-discount tier based on the buy-box quantity and
 * nudges the shopper toward the next tier.
 */
(function () {
  function init(widget) {
    if (widget.dataset.bulkInit) return;
    widget.dataset.bulkInit = '1';

    var chips = Array.prototype.slice.call(widget.querySelectorAll('[data-bulk-min]'));
    if (!chips.length) return;
    var nudge = widget.querySelector('[data-bulk-nudge]');
    var tiers = chips
      .map(function (c) {
        return {
          el: c,
          min: parseInt(c.getAttribute('data-bulk-min'), 10),
          pct: parseInt(c.getAttribute('data-bulk-pct'), 10)
        };
      })
      .sort(function (a, b) {
        return a.min - b.min;
      });

    var info = widget.closest('.m-main-product--info');
    var qtyInput = info ? info.querySelector('.m-quantity__input, input[name="quantity"]') : null;

    function currentQty() {
      var q = qtyInput ? parseInt(qtyInput.value, 10) : 1;
      return isNaN(q) ? 1 : q;
    }

    function render() {
      var qty = currentQty();
      var active = null;
      var next = null;
      tiers.forEach(function (t) {
        if (qty >= t.min) active = t;
        else if (next === null) next = t;
      });
      tiers.forEach(function (t) {
        t.el.classList.toggle('is-active', active && t.min === active.min);
      });
      if (nudge) {
        if (next) {
          var need = next.min - qty;
          nudge.textContent =
            'Add ' + need + ' more tile' + (need === 1 ? '' : 's') + ' to unlock ' + next.pct + '% off your Gym Flooring.';
        } else if (active) {
          nudge.textContent = "You've unlocked our biggest saving — " + active.pct + '% off at ' + active.min + '+ tiles.';
        } else {
          nudge.textContent = 'Buy ' + tiers[0].min + '+ tiles to save ' + tiers[0].pct + '% on your Gym Flooring.';
        }
      }
    }

    if (qtyInput) {
      qtyInput.addEventListener('input', render);
      qtyInput.addEventListener('change', render);
    }
    render();
  }

  function boot() {
    document.querySelectorAll('[data-bulk-tiers]').forEach(init);
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
